/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Exe1Inputs */

const id_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File aplikasi mandiri. Mungkin tidak memerlukan instalasi.`)
};

const ms_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail aplikasi berdiri sendiri. Mungkin tidak memerlukan pemasangan.`)
};

const da_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En selvstændig applikationsfil. Kræver muligvis ikke installation.`)
};

const de_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine eigenständige Anwendungsdatei. Erfordert möglicherweise keine Installation.`)
};

const en_us2_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A standalone application file. May not require installation.`)
};

const es_es2_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo de aplicación independiente. Puede no requerir instalación.`)
};

const es_mx2_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo de aplicación independiente. Puede no requerir instalación.`)
};

const fil_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang standalone application file. Maaaring hindi nangangailangan ng installation.`)
};

const fr_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fichier d'application autonome. Peut ne pas nécessiter d'installation.`)
};

const it_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un file applicativo standalone. Potrebbe non richiedere installazione.`)
};

const hu_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önálló alkalmazásfájl. Lehet, hogy nem igényel telepítést.`)
};

const nl_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een standalone applicatiebestand. Vereist mogelijk geen installatie.`)
};

const no_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En frittstående applikasjonsfil. Kan kreve installasjon.`)
};

const pl_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samodzielny plik aplikacji. Może nie wymagać instalacji.`)
};

const pt_br2_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um arquivo de aplicativo independente. Pode não exigir instalação.`)
};

const pt_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ficheiro de aplicação autónomo. Pode não necessitar de instalação.`)
};

const ro_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fișier de aplicație autonom. Poate nu necesită instalare.`)
};

const fi_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erillinen sovellustiedosto. Ei välttämättä vaadi asennusta.`)
};

const sv_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En fristående applikationsfil. Kräver kanske inte installation.`)
};

const vi_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp ứng dụng độc lập. Có thể không yêu cầu cài đặt.`)
};

const tr_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağımsız bir uygulama dosyası. Kurulum gerektirmeyebilir.`)
};

const cs_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostatný soubor aplikace. Nemusí vyžadovat instalaci.`)
};

const bg_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самостоятелен файл на приложение. Може да не изисква инсталация.`)
};

const ru_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдельный файл приложения. Может не требовать установки.`)
};

const uk_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Окремий файл застосунку. Може не вимагати встановлення.`)
};

const ar_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملف تطبيق مستقل. قد لا يتطلب تثبيتًا.`)
};

const hi_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टैंडअलोन एप्लिकेशन फ़ाइल।`)
};

const th_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์แอปพลิเคชันแบบสแตนด์อโลน อาจไม่ต้องติดตั้ง`)
};

const ja_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンドアロンアプリケーションファイル。インストール不要の場合あり。`)
};

const zh_cn2_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立应用程序文件。可能无需安装。`)
};

const zh_hant1_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獨立應用程式檔案。可能無需安裝。`)
};

const ko_misc_downloads_assetinfo_exe1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Exe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독립 실행형 응용 프로그램 파일입니다. 설치가 필요하지 않을 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "A standalone application file. May not require installation." |
*
* @param {Misc_Downloads_Assetinfo_Exe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_exe1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Exe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Exe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_exe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_exe1(inputs)
	return ko_misc_downloads_assetinfo_exe1(inputs)
});
export { misc_downloads_assetinfo_exe1 as "misc.downloads.assetInfo.exe" }